/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppIntegration } from '../models/WhatsAppIntegration';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingWhatsappRecoveryService {
    /**
     * Verifies and finishes saved setup; does not restart initial contact import.
     * @param integrationProviderId
     * @returns WhatsAppIntegration Ok
     * @throws ApiError
     */
    public static recoverIntegration(
        integrationProviderId: string,
    ): CancelablePromise<WhatsAppIntegration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/messaging/whatsapp/integrations/{integrationProviderId}/recovery',
            path: {
                'integrationProviderId': integrationProviderId,
            },
        });
    }
}
